export const slider_products_collection = "slider-products"
export const highlighted_products_collection = "highlighted-products"
export const internal_shopify_collections_array = [
  slider_products_collection,
  highlighted_products_collection
]